import { render } from "./ethnicity-incremental-field.vue?vue&type=template&id=feee6024"
import script from "./ethnicity-incremental-field.vue?vue&type=script&lang=js"
export * from "./ethnicity-incremental-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__